module.exports = __webpack_public_path__ + "img/EXPLICA.5b975c12.png";